import type { FilterActions, FilterCriteria } from "../../lib/queries";

/** Gmail-style one-line summaries: "from:(billing@x) subject:(Invoice)" and "Skip Inbox, Mark as read". */
export function describeCriteria(c: FilterCriteria): string[] {
  const out: string[] = [];
  if (c.kind) out.push({ newsletter: "newsletters", receipt: "receipts", notification: "notifications", screener: "new senders" }[c.kind]);
  if (c.from) out.push(`from:(${c.from})`);
  if (c.to) out.push(`to:(${c.to})`);
  if (c.subject) out.push(`subject:(${c.subject})`);
  if (c.hasWords) out.push(`has:(${c.hasWords})`);
  if (c.doesNotHave) out.push(`-{${c.doesNotHave}}`);
  if (c.hasAttachment) out.push("has:attachment");
  if (c.sizeOverMb) out.push(`larger:${c.sizeOverMb}M`);
  if (c.sizeUnderMb) out.push(`smaller:${c.sizeUnderMb}M`);
  return out;
}

export function describeActions(a: FilterActions): string[] {
  const out: string[] = [];
  if (a.skipInbox) out.push("Skip the Inbox");
  if (a.markRead) out.push("Mark as read");
  if (a.star) out.push("Star it");
  if (a.moveTo) out.push(`Move to ${a.moveTo}`);
  if (a.forwardTo) out.push(`Forward to ${a.forwardTo}`);
  if (a.delete) out.push("Delete it");
  if (a.spam) out.push("Send to Spam");
  return out;
}

/** A blocked sender is a filter that only matches a sender and only sends to Spam. */
export function isBlockRule(c: FilterCriteria, a: FilterActions): boolean {
  const onlyFrom = Boolean(c.from) && !c.to && !c.subject && !c.hasWords && !c.doesNotHave && !c.hasAttachment && !c.sizeOverMb && !c.sizeUnderMb;
  const onlySpam = Boolean(a.spam) && !a.markRead && !a.star && !a.skipInbox && !a.moveTo && !a.forwardTo && !a.delete;
  return onlyFrom && onlySpam;
}
